import * as React from 'react';

import Plus16 from './Plus16';

export const plus16 = () => <Plus16 />;

export default {
    title: 'Icon|Line|Plus16',
    component: Plus16,
    parameters: {
        notes: "`import Plus16 from 'box-ui-elements/es/icon/line/Plus16';`",
    },
};
